import React, { useEffect, useRef, useState } from "react";
import Icon from "./Icon";

/**
 * Image with a reserved aspect ratio (no layout shift), shimmer while loading,
 * native lazy loading, and a graceful fallback when the file is missing.
 * fit="contain" places product photos on a neutral stage; "cover" fills.
 */
function ProductImage({
  src,
  alt = "",
  ratio = "4 / 3",
  fit = "contain",
  priority = false,
  width = 800,
  height = 600,
  sizes,
  className = "",
}) {
  const [status, setStatus] = useState(src ? "loading" : "error");
  const imgRef = useRef(null);

  useEffect(() => {
    setStatus(src ? "loading" : "error");
  }, [src]);

  useEffect(() => {
    const img = imgRef.current;
    if (img && img.complete && img.naturalWidth > 0) setStatus("loaded");
  }, [src]);

  return (
    <span
      className={`v-img v-img--${fit} is-${status} ${className}`}
      style={{ aspectRatio: ratio, "--ratio-fallback": ratio }}
    >
      {status === "error" ? (
        <span className="v-img__fallback">
          <Icon name="box" size={28} />
          <span>Image unavailable</span>
        </span>
      ) : (
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          width={width}
          height={height}
          sizes={sizes}
          loading={priority ? "eager" : "lazy"}
          decoding={priority ? "sync" : "async"}
          fetchpriority={priority ? "high" : undefined}
          onLoad={() => setStatus("loaded")}
          onError={() => setStatus("error")}
        />
      )}
    </span>
  );
}

export default React.memo(ProductImage);
